import api from "../axios/api";
import { IPayload } from "../models/ipayload";
import Axios from "axios";
import { ISite } from "../models/isite";
import { IPlace } from "../models/iplace";
import siteObjectToQuery from "../utils/siteObjectToQuery";
let CancelToken = Axios.CancelToken;
let fetchPlacesLeafsService_cancel: any
let fetchPlacesRootsService_cancel: any
let fetchPlacesByIdService_cancel: any



export const fetchPlacesLeafsService = (sites: Array<ISite>): Promise<IPayload<IPlace>> => {
  fetchPlacesLeafsService_cancel && fetchPlacesLeafsService_cancel()

  const query = `?${sites && sites.length > 0 ? 'sites=' + siteObjectToQuery(sites) : ''}`
  return api.get('/places/leafs' + query, {
    cancelToken: new CancelToken(function executor(c) {
      fetchPlacesLeafsService_cancel = c;
    })
  })
}

export const fetchPlacesRootsService = (sites: Array<ISite>): Promise<IPayload<IPlace>> => {
  fetchPlacesRootsService_cancel && fetchPlacesRootsService_cancel()

  const query = `?${sites && sites.length > 0 ? 'sites=' + siteObjectToQuery(sites) : ''}`
  return api.get('/places/roots' + query, {
    cancelToken: new CancelToken(function executor(c) {
      fetchPlacesRootsService_cancel = c;
    })
  })
}

export const fetchPlacesByIdService = (id: string): Promise<IPlace> => {
  fetchPlacesByIdService_cancel && fetchPlacesByIdService_cancel()

  return api.get(`/places/${id}`, {
    cancelToken: new CancelToken(function executor(c) {
      fetchPlacesByIdService_cancel = c;
    })
  })
}
